import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import PageHeader from "../../components/shared/PageHeader";
import Loading from "../../components/shared/Loading";
import apiClient from "../../components/utils/apiClient";
import useUser from "../../components/helpers/useUser";
import { PACKAGE_BACKGROUND } from "../../components/styles/media";
import SarIcon from "../../components/icons/SarIcon";
import CheckCircleIcon from "../../components/icons/CheckCircleIcon";
import TimesIcon from "../../components/icons/TimesIcon";
import CheckIcon from "../../components/icons/CheckIcon";
import ModalContainer from "../../containers/shared/ModalContainer";
import moment from "moment";
import Toast from "../../components/shared/Toast";

const PackagesPage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle(t('packages.pageTitle'));
    const navigate = useNavigate();
    const [user,setUser] = useUser();
    const [vendor,setVendor] = useState(null);
    const [plans,setPlans] = useState(null);
    const [currentPlan,setCurrentPlan] = useState(null);
    const pageTitle = {title: t('packages.pageTitle')};
    const [isLoading,setIsLoading] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [showTermsAndConditionsModal, setShowTermsAndConditionsModal] = useState(false);
    const [toast,setToast] = useState(null);
    
    
    const getUserData = async () => {
      try {
        const response = await apiClient.get(`vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])


    const getPlans = async () => {
        try {
            const response = await apiClient.get(`/fanni-vendor/plans`);
            if(response && response.status && (response.status === 204 || response.status === 200)) {
              setPlans(response.data);
              if(vendor?.activeSubscription) {
                setCurrentPlan(response.data.findIndex(plan => plan?._id === vendor?.activeSubscription?.plan?._id));
              }
            } else {

            }
        } catch (error) {}
    }

    useEffect(()=>{
      if(vendor) {
        getPlans();
      }
    },[vendor])


    const SubScribe = (planId) => {
      setSelectedPackage(planId);
      setShowTermsAndConditionsModal(true);
    }
    const SubScribeAction = async () => {
        const body = {
            "planId": selectedPackage,
            "frontEndCallback": window.location.origin+`/${i18n?.language || 'ar'}/settings`
            }
            setIsLoading(true);
        try {
            const response = await apiClient.post(`/vendors/subscribe`,body);
            if(response && response.status && (response.status === 204 || response.status === 200)) {
                // console.log(response.data);
                if(response.data.formUrl) {
                  window.location.href = response.data.formUrl;
                }
                if(response.data.isActive) {
                  navigate(`/${i18n?.language || 'ar'}/wallet?status=paid`);
                }
            } else {
              setIsLoading(false)
            }
        } catch (error) {
          if(error?.response?.data?.message) {
            setToast({show:true,type:'error',message:error.response.data.message});
          }
          setIsLoading(false)
          setShowTermsAndConditionsModal(false)
        }
    }

    const handleCloseModal = () => {
      setShowTermsAndConditionsModal(false);
    }

    const getSubscribeButtonTitle = (isTrialPlan) => {
      return isTrialPlan ? t('packages.startTrial') : t('packages.subscribe');
    }
    
  return (
    <div>
      <PageHeader pageTitle={pageTitle} />
      <PageMain>
        <MainContent>
          {plans?.[0]?.isTrialPlan ? <div className="bg-white rounded-[16px] p-[16px] border-[1px] border-grey-300 text-grey-600 font-[700] text-[24px] mt-[24px] max-w-[1166px] mx-auto">
            <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[16px]">
              <path d="M48.8037 30.1309C50.3988 28.5342 50.3988 25.9459 48.8037 24.3515L24.4779 0L3.26231 21.2381C-0.991169 25.4961 -1.12291 32.4271 3.08822 36.7251C7.3417 41.0656 14.3289 41.0915 18.6129 36.8029L24.7555 30.6537L29.2537 35.1567C30.8487 36.7534 33.4366 36.7534 35.0317 35.1567C36.6267 33.5599 36.6267 30.974 35.034 29.3773L24.7697 19.0785L12.8844 30.9764C11.8281 32.0338 10.1083 32.1139 9.01203 31.0989C7.86162 30.0296 7.83574 28.2209 8.93439 27.1211L24.4756 11.5635L43.0258 30.1333C44.6255 31.7253 47.211 31.7253 48.8037 30.1309Z" fill="#0F172A"/>
            </svg>
            {t('packages.freeTrialMessage', {date: moment(plans?.[0]?.trialEndDate).format('DD/MM/YYYY')})}
          </div> : ''}
          <div className="flex flex-wrap lg:flex-nowrap gap-x-[25px] my-[40px] justify-center">
          { plans && plans.map((plan, index) => (
            <div key={'packeges-'+index} className={`w-full lg:w-[33.333%] mb-[25px] lg: max-w-[372px] relative transition-transform hover:scale-105 rounded-[32px] ${index === 0 ? 'bg-[#F3F7F5] text-grey-700' : index === 1 ? 'bg-[#BCC6CC] text-grey-900' : 'bg-[#D3AF37] text-white'}`}>
              <div className="w-fill h-full pt-[8px]">
                <div className="w-full h-[56px] leading-[56px] font-[700] text-[30px] cairo-font px-[20px]">{plan?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || plan?.name?.ar}</div>
                <div className="w-full h-[84px] leading-[84px] font-[600] text-[56px] pop-font px-[20px]">
                  <span className={`relative inline-block w-fit ${plan?.isTrialPlan ? 'opacity-50' : ''}`}>{plan?.price}{plan.isTrialPlan ? <span className={`w-full absolute top-[50%] end-0 border-t-[3px] ${index === 0 ? 'border-[#334155]' : index === 1 ? 'border-[#0F172A]' : 'border-white'}`}></span> : ''}</span>
                  {plan?.isTrialPlan ? <span className={`relative inline-block w-fit ms-[15px]`}>0</span> : ''}
                  <SarIcon color={index === 0 ? '#334155' : index === 1 ? '#0F172A' : 'white'} width={41} height={44} pathURL={'package-sar-'+index} />
                  {plan?.isTrialPlan
                  ? <span className="cairo-font font-[500] text-[18px] inline-block ms-[3px]"></span>
                  : <span className="cairo-font font-[500] text-[18px] inline-block ms-[3px]">/{t('packages.annually')}</span>}
                </div>
                <div className="w-full h-[52px] leading-[26px] font-[500] text-[14px] cairo-font px-[20px]">{plan?.description?.[i18n.language === 'ar' ? 'ar' : 'en'] || plan?.description?.ar}</div>
                <div className="font-[400] text-[12px] cairo-font leading-[22px] h-[22px] px-[20px]">{t('packages.oneTimeRegistrationFee')}</div>

                <div className={`mx-[20px] my-[8px] border-t ${index === 0 ? 'border-[#EDF2F0]' : index === 1 ? 'border-[#A8B2B8]' : 'border-[#B69422]'}`}></div>

                <div className="px-[20px]">
                  <div className="cairo-font leading-[37px] font-[500] text-[20px] mb-[8px]">
                    <CheckCircleIcon color={index === 0 ? '#334155' : index === 1 ? '#0F172A' : 'white'} />
                    {t('packages.techCount')}{plan?.features?.TechniciansCount > 0 ? plan?.features?.TechniciansCount : t('packages.unlimited')}</div>
                  <div className="cairo-font leading-[37px] font-[500] text-[20px] mb-[8px]">
                    <CheckCircleIcon color={index === 0 ? '#334155' : index === 1 ? '#0F172A' : 'white'} />
                    {t('packages.citiesCount')}{plan?.features?.CitiesCount > 0 ? plan?.features?.CitiesCount : t('packages.unlimited')}</div>
                </div>

                <div className="mx-[1px] px-[20px] py-[16px] bg-white">
                  <p className="cairo-font leading-[37px] h-[37px] mb-[12px] text-grey-900 font-[500] text-[20px]">
                    {index === 0
                    ? <TimesIcon />
                    : <CheckIcon /> }
                    {t('packages.exportReports')}
                  </p>
                  <p className="cairo-font leading-[37px] h-[37px] mb-[12px] text-grey-900 font-[500] text-[20px]">
                    {index === 0
                    ? <TimesIcon />
                    : <CheckIcon /> }
                    {t('packages.performanceAnalysis')}
                  </p>
                  <p className="cairo-font leading-[37px] h-[37px] mb-[12px] text-grey-900 font-[500] text-[20px]">
                    {index !== 2
                    ? <TimesIcon />
                    : <CheckIcon /> }
                    {t('packages.businessSector')}
                  </p>
                  <p className="cairo-font leading-[37px] h-[37px] text-grey-900 font-[500] text-[20px]">
                    {index !== 2
                    ? <TimesIcon />
                    : <CheckIcon /> }
                    {t('packages.custodyManagement')}
                  </p>
                </div>

                <div className={`w-full h-[56px] leading-[56px] text-center cairo-font cursor-pointer font-[700] text-[18px] rounded-br-[32px] rounded-bl-[32px]
                  ${currentPlan !== null
                  ? index <= currentPlan
                  ? 'opacity-50 pointer-events-none cursor-default'
                  : ''
                  : ''
                  }`}
                  
                  onClick={() => 
                    currentPlan !== null
                  ? index <= currentPlan
                  ? ''
                  : SubScribe(plan?._id)
                  : SubScribe(plan?._id)
                  }
                  >
                  {currentPlan !== null
                  ? index <= currentPlan
                  ? getSubscribeButtonTitle(plan?.isTrialPlan)
                  : t('packages.upgradePackage')
                  : getSubscribeButtonTitle(plan?.isTrialPlan)
                  }
                </div>
              </div>
              {index === 1 && <span className="absolute top-[-13px] left-[32px] bg-orange text-white px-[8px] h-[37px] leading-[37px] rounded-full text-center text-[20px] font-[500] cairo-font">{t('packages.mostChosen')}</span>}
            </div>
          ))}
          </div>
        </MainContent>
      </PageMain>

      { showTermsAndConditionsModal && <ModalContainer maxWidth={'775px'} heading={t('packages.termsModalHeading')} handleCloseModal={handleCloseModal}>
        <div className="text-center">
          <img src="/assets/images/logo-b.svg" alt="" className="w-[88px] h-[134px] mb-[24px] mx-auto" />
          <h2 className="font-bold text-[26px]">{t('packages.termsModalHeading')}</h2>
          <div className="w-full h-[400px] border-grey-200 border-[1px] rounded-[16px] p-[16px] overflow-y-auto text-start mb-[25px] mt-[20px]">
            تقوم شركة فني البيت للخدمات التجارية / أو الشركات التابعة لها يشار إليها مجتمعة أو منفرده بـ ("فني"، "نحن"، "التطبيق" او "فاب") بجمع معلومات عنك عند استخدامك لتطبيقات الهاتف المحمول الخاصة بنا والمواقع الإلكترونية ومركز الاتصال ومنتجات وخدمات أخرى خاصة بنا (يشار إليها مجتمعة بـ "الخدمات") ومن خلال التفاعلات والاتصالات الأخرى الخاصة بك معنا. تنص سياسة الخصوصية هذه على الأساس الذي سوف تعتمد عليه فني في معالجة المعلومات بما في ذلك البيانات الشخصية التي نجمعها منك أو تزودها أنت لنا. في كل مرة تدخل فيها أو تستخدم الخدمات أو تزودنا بمعلومات، فإنك بقيامك بذلك تقبل وتوافق على الممارسات المبينة في سياسة الخصوصية هذه.
            <br />
            <br />
            يشار إلى الفني (مقدم الخدمات أو مزود الخدمة") سواء استفاد من خدمة التطبيق أو قام بالتسجيل على التطبيق فقط دون الموافقة على أي طلب
            <br />
            <br />
            وتمثل هذه الضوابط والشروط اتفاق رسمي "عقد" بين شركة فني البيت للخدمات التجارية المالك للعلامة التجارية "فني" سجل تجاري رقم 4030289212 ومقدمي خدمات الصيانة "الفنيين" وتحكم شروط مقدم الخدمة هذه استخدامكم لتطبيق "فاب" والذي هو عبارة عن منصة إلكترونية تسمح للفنيين بتقديم خدمات الصيانة للعملاء في المواقع الذي يحددها العميل مسبقاً، حيث يقوم "فني " بإتاحة الفرصة للعميل لاختيار الفني المناسب للقيام بعملية الصيانة.
            <br />
            <br />
            وفي حال استمرارك لاستخدام التطبيق بعد نشر الاتفاقية يعد هذا موافقة منك على الالتزام بهذه الاتفاقية بصيغتها المعدلة
            <ol style={{listStyleType: 'decimal', marginInlineStart: '25px'}}>
                <li>
                    <p className="font-bold"> سياسة الخصوصية:</p>
                    <p>إن اي استخدام من قبلك للخدمات التي يوفرها تطبيق “فاب” يشكل موافقة منك على هذا العقد وأحكامه وتبعاً لذلك يجب عليك عدم استخدام التطبيق في حال لم تكن موافقاً على الأحكام والشروط الواردة في هذا العقد.</p>
                </li>
                <li>
                    <p className="font-bold">	جمع المعلومات:</p>
                    <p>نحن نقوم بجمع المعلومات التي تقدمها لنا مباشرة من خلال وصولك أو استخدام للخدمات، مثلا، عندما تقوم بإنشاء أو تعديل الحساب الخاص بك، أو تقديم خدمة، أو الاتصال بمركز العناية بالعملاء أو الاتصال بنا بطرق أخرى. يمكن أن تتضمن هذه المعلومات: اسمك، تاريخ ميلادك، البريد الإلكتروني، رقم الجوال أو الهاتف، العنوان البريدي، صورة الملف الشخصي، وأي معلومات أخرى تختار تقديمها لنا.</p>
                </li>
                <li>
                    <p className="font-bold">	معلومات نقوم بجمعها من خلال استخدامك لخدماتنا:</p>
                    <p>عندما تقوم باستخدام خدماتنا، نقوم بجمع معلومات (أي معلومات يمكن استخدامها للاتصال بك مباشرة مثل الاسم الكامل والعنوان البريدي ورقم الهاتف أو عنوان البريد الإلكتروني) ("المعلومات الشخصية)" والمعلومات الديموغرافية (أي المعلومات التي تقدمها أو التي نجمعها ولا تكون معلومات شخصية، يشمل ذلك، دون حصر، الرمز البريدي، البلد الأصلي، الجنس، اسم المستخدم، معلومات النظام، يشمل ذلك نوع جهاز الهاتف المحمول الذي تستخدمه، معرف الجهاز المميز (على سبيل المثال رقم IMEI للجهاز الخاص بك، عنوان الماك لواجهة الشبكة اللاسلكية للجهاز، أو رقم الهاتف المحمول المستخدم بواسطة الجهاز)، معلومات شبكة الهاتف المحمول، نظام تشغيل الهاتف، نوع متصفح الهاتف المحمول الذي تستخدمه، إعدادات المنطقة الزمنية، موقع الجهاز، عنوان بروتوكول IP، بيانات الرسائل القصيرة، معلومات التعاملات، العمر/ تاريخ الميلاد، معلومات سجل التصفح، معلومات سجل البحث، ومعلومات سجل التسجيل (" المعلومات الديموغرافية"، إلى جانب المعلومات الشخصية، "البيانات الشخصية")
                        <br /><br />
                        كما نستخدم أيضا تقنية نظام تحديد المواقع (GPS) لتحديد موقعك الحالي. لتقديم الخدمات الخاصة بنا التي تطلب مشاركة الموقع تطلب بياناتك الشخصية للعمل في المستقبل. إذا كنت ترغب باستخدام خاصية معينة، سوف يطلب منك الموافقة على البيانات التي يجري استخدامها لهذا الغرض.
                    </p>
                </li>
                <li>
                    <p className="font-bold">	أحقية تقديم الخدمات</p>
                    <p>أنت تقر وتضمن التالي:</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li>أنه لم يسبق أن تم ايقاف استخدامك لخدمات " فاب - فني " أو منعك من استخدامها في اي وقت من الأوقات.</li>
                        <li> أنك لست منافساً ل" فني – فاب " كما أنك لا تقدم اي منتج منافس للخدمات المقدمة .</li>
                        <li> من اجل استخدام منصة "فاب" يتعين ان يبلغ عمرك 18 عام على الأقل حتى يتسنى لك الحصول على حساب</li>
                        <li> يتطلب تسجيل الحساب تقديم بعض المعلومات الشخصية الى شركة فني مثل ( اسمك – عنوانك – رقم هاتفك –بيانات الكفيل –جنسك – رقم الهوية  – تاريخ الميلاد  - السجل التجاري )</li>
                        <li> ان يكون لديك (هوية – إقامة) نظامية سارية في المملكة العربية السعودية .</li>
                        <li> إذا كنت تملك اقامة فانت تقر انها اقامة نظامية سارية وان المهنة التي تقدمها نفس المهنة الموجودة في الاقامة وفي حال اي تغيير يحدث يجب عليك تحديث معلوماتك لدينا وتقر بانك تعمل لدى كفيلك</li>
                        <li> ليس لك أي حق في تقديم أي عروض للمستخدمين نيابة عن شركة فني، وأنت تقر بأن خرقك لهذا البند سوف يجعلك مسؤولا مسؤولية كاملة عن جميع الالتزامات الناشئة عن هذا الخرق ويعرضك للملاحقة الجنائية وحظر استخدامك للمنصة</li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">التعهدات والضمانات</p>
                    أنت تقر بأنك سوف:
                    <br />
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li>	المحافظة على سمعة التطبيق "فني – فاب" واحترام العميل في المقام الأول.</li>
                        <li>	الالتزام بتقديم الخدمة مباشرة فور استلامك للطلب والتواجد في موقع العميل بدون تأخير.</li>
                        <li>	النظافة الشخصية واللبس اللائق للعمل.</li>
                        <li>	وجود الأدوات الكاملة اللازمة لتقديم خدمة الصيانة المنزلية.</li>
                        <li>	الكشف والمشوار مجانًا، ويمنع إضافة رسوم عليها.</li>
                        <li>	تمتثل لكافة القوانين واللوائح المعمول بها في المملكة العربية السعودية.</li>
                        <li>	قدم معلومات صحيحة ودقيقة إلى “شركة فني” وتقوم بتحديثها في حال طرأ أي تغيير .</li>
                        <li>	تراجع وتمتثل لأي إشعارات يتم إرسالها من خلال تطبيق “فاب” فيما يتعلق باستخدامك للخدمة المقدمة من تطبيق “فني - فاب”.</li>
                        <li>	لن تقوم بعمل تراخيص من الباطن، أو إصدار أو نشر أو نقل أو توزيع أو تنفيذ أو عرض أو بيع أو إعادة تصنيف خدمات “فني - فاب”, والا فإنك تكون قد نقلت الخدمة أو قمت باستغلالها تجارياً، باستثناء ما يسمح به بموجب هذا العقد، ومعرض المساءلة القانونية.</li>
                        <li>	لن تستخدم المعلومات، أو المحتوى أو أي بيانات تصل إليها أو تحصل عليها من خلال خدمات “فني - فاب” في أي غرض آخر إلا للاستعمال الشخصي وسوف تستخدم التطبيق والخدمة حصراً للأغراض الخاصة بك ولن تبيعها لأي طرف ثالث (بما في ذلك على سبيل المثال لا الحصر نقل حسابك إلى أي شخص آخر او نشر ارقام العملاء لاطراف اخرين ).</li>
                        <li>	سوف تستخدم الخدمة أو التطبيق لأغراض مشروعة فقط، ولن تستخدم الخدمات لإرسال أو تخزين أي مواد غير قانونية أو بهدف الاحتيال.</li>
                        <li>	تلتزم بالمحافظة على سلامة موقع العمل ونظافة المكان اثناء وبعد العمل .</li>
                        <li>	لن تستخدم الخدمة أو التطبيق للتسبب بإيذاء أو مضايقة أو إزعاج أحد ما.</li>
                        <li>	لن تعرقل التشغيل السليم لتطبيق "فني – فاب"..</li>
                        <li>	الالتزام بعدم التواصل مع العميل بعد (اكتمال أو الغاء الطلب) وهذا يعرضك للمساءلة القانونية وإيقاف حسابك دون الرجوع إليك ودون استعادة أي مبالغ موجودة في الحساب (الرصيد – الدخل)</li>
                        <li>	لن تحاول إلحاق الضرر بالخدمة أو التطبيق بأي شكل من الأشكال.</li>
                        <li>	لن تنسخ أو توزع التطبيق أو المحتويات الأخرى دون الحصول على إذن كتابي من "فني – فاب".</li>
                        <li>	سوف تحافظ على كلمة المرور لحسابك أو أي وسيلة تعريف نقدمها لك وتتيح الدخول إلى حسابك، بشكلٍ آمن وسري.</li>
                        <li>	سوف تقدم لنا كافة الدلائل التي تثبت هويتك وفقاً لتقدير "فني – فاب" الخاص.</li>
                        <li>	يحق لـ"فني - فاب" رفض تقديم الخدمة أو استخدام التطبيق دون إبداء أسباب.</li>
                        <li>	الالتزام بالأسعار المحددة داخل التطبيق، وفي حال وجود أي أعمال أخرى لا تشملها قائمة الأسعار يجب الالتزام بالسعر العادل.</li>
                        <li>	يتوجب عليك الالتزام بالعمل ضمن فترات العروض، ورفضها يعرضك لاتخاذ إجراء بحقك قد يصل إلى إيقاف حسابك دون الرجوع إليك.</li>
                        <li>	تقر بانك لن تقوم بعمل طلبات او تقييمات وهمية</li>

                        أنت تضمن أن:
                        <li> تلتزم بتقديم الخدمة حسب المواصفات الفنية المتعارف عليها عند ذوي الخبرة والاختصاص.</li>
                        <li> في حال وجود شكوى يتوجب عليك العودة للعميل في حال وجود خلل أو عودة المشكلة السابقة واصلاحها خلال فترة الضمان المحددة من تاريخ الفاتورة.</li>
                        <li> توفير قطع غيار سليمة وبجودة عالية وسعر عادل، واحضار فاتورة معتمدة وتسليمها للعميل ،وعدم تسليمها للعميل يعرضك لإيقاف حسابك دون الرجوع إليك .</li>
                        <li> في حال تغيير أي قطعة؛ يجب تسليم القطعة التالفة أو القديمة للعميل ولا يحق لك الحصول عليها أو الاستفادة منها، وقد تعرض نفسك لغرامة مالية أمام الجهات القانونية وإيقاف حسابك دون الرجوع اليك.</li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">نطاق الترخيص</p>
                    يمنحك "فني " ترخيص غير حصري، وغير قابل للتحويل، وغير قابل للتنازل، وغير قابل للترخيص من الباطن وغير قابل للإلغاء وذلك للحصول على خدماتنا واستخدامها فقط للغرض الشخصي (ليس لأي أغراض تجارية على سبيل المثال لا الحصر) وفقاً لهذا العقد، لذا يجب عليك:
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li>	تتعهد بانك المستخدم الوحيد للحساب وتلتزم بعد اتاحة استخدام حساب من قبل اشخاص اخرين
                        </li>
                        <li>	عدم حذف، أو تغيير، أو غير ذلك من التعديل على أي حق من حقوق النشر أو غيرها من الإخطارات الرسمية الواردة في الخدمات.
                        </li>
                        <li>	عدم تعمد نقل، أو توزيع الخدمات، أو السماح بتحميل الخدمات للاستخدام بخلاف ما هو محدد هنا.
                        </li>
                        <li>	عدم السماح بمشاركة اسم المستخدم/ أو كلمة المرور أو غيرها من مسوغات الوصول إلى خدمات “فاب”.
                        </li>
                        <li> يحتفظ فني بالحق في السعي لتنفيذ أي معالجات متاحة لأي خرق لسياسة شحن الرصيد ويشمل ذلك، دون حصر، الحق في حجب إمكانية الوصول إلى خدمات وبرامج فني.</li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">حقوق الملكية الفكرية</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> تبقى جميع حقوق الملكية الفكرية لهذه الخدمات وكافة المواد المتعلقة بها أو التي تظهر عليها (وتشمل أي محتوى تقوم بتقديمه أو بإدراجه - على سبيل المثال لا الحصر) هو ملكية لـ”فني”. ولا تمنحك هذه الاتفاقية ولا استخدامك لمنصة "فني" أي حقوق باستثناء ما ورد في هذه الاتفاقية.
                        </li>
                        <li> المحافظة على سرية المعلومات التي حصلت عليها من قبل شركة "فني" أو الإشارة بأي صورة إلى طريقة الاستخدام أو الإجراءات الداخلية المتعلقة بالشركة.
                        </li>
                        <li> يجب عليك ألا تقوم بإعادة إنتاج أو السماح لأي شخص، لأي سبب من الأسباب، باستخدام أو إعادة إنتاج الخدمات أو أي علامات تجارية أو غيرها من الأسماء التجارية التي تظهر في الخدمات.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">الدفع</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> لـ" فني " الحق بفرض رسوم جديدة على استخدام التطبيق او الخدمة او كليهما
                        </li>
                        <li> لا يجوز لمزود الخدمة المطالبة باي مبالغ تم شحنها في رصيدة او أي اشتراكات داخل التطبيق
                        </li>
                        <li> في حال تم تغيير الرسوم او النسبة فإنة سيتم اشعارك بذلك ويمكنك الاستمرار اوالغاء الحساب
                        </li>
                        <li> تقوم "فني" بتحديد نسبة العمولة الخاصة بـ ("مزود الخدمة"، "الفني") ويتم تحصيلها من الفني وفق ما يتطلبه السوق، ويكون من حق الفني طلب عدم الاستمرار في حال عدم مناسبة النسبة المقدمة من "فني"، ويعد استمراره بعد إخطاره بالنسبة الجديدة موافقة صريحة منه على النسبة الجديدة.
                        </li>
                        <li> يجوز ل"فني" تعديل أو تحديث الأسعار من وقت لآخر، وتكون مسؤول مسؤولية كاملة عن البقاء على معرفة بالأسعار الحالية لخدمة الصيانة.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">	 يجوز ل"فني" الغاء الاشتراك وشطب الحساب نهائيا وخصم الرصيد بالحساب عند عدم استخدامك ل"فاب" ما يتعدى 3 اشهر من اخر استخدام</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> يتوجب عليك القبول بأي عروض أو خصومات عند الإعلان عنها وعندما يقوم العميل باستخدام كود خصم في الطلب.
                        </li>
                        <li> يتوجب عليك استلام قيمة خدمة الصيانة من العميل النهائي نقداً – اونلاين، وفور تقديم الخدمة، وتتحمل وحدك مسؤولية عدم استلام قيمة خدمة الصيانة، وإنك تقر بأن تدفع ل"فني" نسبته المتفق عليها من كل طلب تقوم به.
                        </li>
                        <li> لا يجوز لمزود الخدمة اجبار العميل على طريقة الدفع وفي حال اجبار العميل تعرض حسابك للايقاف دون الرجوع إليك.</li>
                        <li> يجوز لفني حجز مبلغ الدخل الخاص بمزود الخدمة حتى انتهاء فترة الضمان للطلب </li>
                        <li> تقر وتوافق بأن تلتزم بالأمانة دائماً فيما يتعلق بقيمة وحقيقة العمليات وخلافه، وتوافق بأنه في حال اكتشاف أي تحايل أو تلاعب أو مخادعة أو اساءة تقديم الخدمة للعميل بما يسئ للتطبيق بشكل مباشر أو غير مباشر، فإنك ستكون عرضة لإيقاف الخدمات الخاصة بك وحجبها عن تطبيق "فاب" وخصم كامل رصيدك دون الرجوع إليك، بالإضافة إلى حق "فني" بالمطالبة بالتعويضات عن كافة الأضرار التي نتجت أو ستنتج نتيجة لهذا التحايل والتلاعب أو سوء الاستخدام.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">التعويض</p>
                    بموافقتك على شروط الاستخدام فإنك توافق على الدفاع عن "فني" والشركات التابعة لها وكل مسؤول من مسؤولي الشركة وابراء ذمتهم من أي مطالبات وتكاليف او اضرار او خسائر تنشأ او ترتبط بـ :
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> انتهاكك او مخالفتك لأي شرط من شروط الاستخدام هذه او أي قانون او لوائح معمول بها ، سواء كانت مضافه في هذه اللائحة او لا
                        </li>
                        <li> انتهاكك لأي حقوق تخص مقدمي الخدمة او الإساءة لهم باي شكل من الاشكال
                        </li>
                        <li> استخدامك او إساءة استخدامك للتطبيق او الخدمة.</li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">المسؤولية القانونية</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> المعلومات والتوصيات والخدمات أو أي منها التي قُدمت لك على أو من خلال موقع الويب والخدمة والتطبيق هي لأغراض المعلومات العامة فقط ولا تمثل أي نصيحة.
                        </li>
                        <li> ستحافظ "فني" قدر الإمكان على صحة وتحديث الموقع والتطبيق ومحتوياته، لكنها لا تضمن أن (محتويات) الموقع أو التطبيق خالية من الأخطاء والعيوب والبرامج الضارة والفيروسات ولا تضمن صحة ودقة وتحديث موقع الويب والتطبيق.
                        </li>
                        <li> لا يتحمل "فني" المسؤولية عن أي أضرار تنتج عن استخدام (أو عدم القدرة على استخدام) الموقع أو التطبيق، بما في ذلك الأضرار التي تسببها البرامج الضارة أو الفيروسات، كما لا تتحمل مسؤولية عدم صحة أو عدم اكتمال المعلومات أو موقع الويب أو التطبيق.
                        </li>
                        <li> تقع مسؤولية جودة خدمة الصيانة المطلوبة باستخدام التطبيق أو الخدمة بأكملها عليك، ولا يتحمل "فني" أي مسؤولية في هذا الجانب، على أن من حق "فني" مراجعة أدائك وبناءً عليه إلغاء حسابك.
                        </li>
                        <li> لا يقبل "فني" تحت أي ظرف من الظروف أي مسؤولية تتعلق بخدمات الصيانة التي يقدمها مزود الخدمة أو تنشأ عنها بعد انتهاء فترة الضمان.
                        </li>
                        <li> "فني" غير مسؤول عن أي أفعال أو تصرفات أو سلوك أو إهمال، من جانب مزود خدمة الصيانة.
                        </li>
                        <li> إن أي شكاوى بشأن خدمات الصيانة تقدم من قبل العملاء، ينبغي تقديمها لـ"تطبيق فني" بشكل مباشر، على أن "فني" لا يتحمل أي مسؤولية في هذا الجانب، ويكون فقط حلقة وصل بين الطرفين.
                        </li>
                        <li> لـ" فني " الحق في تقديم أي معلومات للجهات الرسمية في حال طلب منها ذلك.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">تعديل الخدمات:</p>
                    يحتفظ "فني" بحقه، وبإرادته المنفردة، بأن يقوم في أي وقت بالآتي:
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> تغيير الخدمات أو أي مواد مرتبطة بها؛ و/ أو إيقاف نشر خدماتها.</li>
                        <li> إذا قرر "فني" إيقاف نشر خدماتها، فإنها قد تقوم بإرادتها باستبدال الخدمات بخدمات أخرى مشابهة
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">حدود المسئولية:</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> لا يقدم " فني" أي ضمان على قطع الغيار التي قد توفرها للعميل.</li>
                        <li> لن يكون "فني" أو وكلائه أو مانحي التراخيص أو الشركات التابعة له مسئولة في أي حال من الأحوال عن الأضرار المباشرة أو غير المباشرة أو الجزاءات أو الأضرار الخاصة أو حدوث أضرار عرضية أو تبعية (وتشمل على سبيل المثال لا الحصر، الأضرار الناتجة عن خسارة الأرباح، تعطل الأعمال، فقدان معلومات الأعمال أو غيرها من الخسائر المالية) الناجمة بشكل مباشر أو غير مباشر عن الوصول إلى الخدمات واستخدامها (أو الفشل في استخدامها) أو الاعتماد عليها.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">الأمان</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> إنك تقر بتحملك المسئولية منفرداً عن خصوصية الخدمات، وتكون مسئولاً منفرداً عن استخدامها من قبل أي شخص آخر باستخدام حسابك و/أو اسم المستخدم أو كلمة المرور أو مسوغات الوصول الخاصة بك.
                        </li>
                        <li> كما أنك توافق على إشعار "فني" إذا أصبحت على علم بأي خسارة، أو سرقة، أو استخدام غير مصرح به لأي كلمة مرور، أو اسم مستخدم أو عنوان بروتكول الانترنت IP، أو غير ذلك من أساليب الوصول إلى الخدمات.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">مدة العقد وإنهاؤه</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> يكون العقد المُبرم بينك وبين “شركة فني ” غير محدد المدة. ويحق لك إنهاء العقد في أي وقت بحذف التطبيق المُثبّت على هاتفك الذكي حذفًا نهائيًا، وبذلك تعطل استخدامك للتطبيق والخدمة.
                        </li>
                        <li>
                            يحق ل”فني” إنهاء العقد بأثر فوري في أي وقت (بتعطيل استخدامك للتطبيق والخدمة)، وذلك في حالة قيامك بأي مما يلي:
                            <ol>
                                <li> عدم الالتزام بأي شرط من شروط مقدم الخدمة.</li>
                                <li> في حال اساءتك استخدام التطبيق أو الخدمة.</li>
                                <li> ولفني الحق في انهاء العقد بدون اخبارك بإنهاء العقد</li>
                            </ol>
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">تعديل الخدمة وشروط مقدم الخدمة</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> ل" فني " وحدها الحق في تعديل أي شرط من شروط مقدم الخدمة أو تغيير الخدمة أو التطبيق أو تعليقهما أو إيقافهما (بما في ذلك على سبيل المثال لا الحصر، إيقاف خدمة من الخدمات المقدمة) في أي وقت، وذلك بإرسال اشعار لك من خلال الخدمة أو التطبيق.
                        </li>
                        <li> يجوز ل”فني” أن تضع قيودًا على ميزات وخدمات مُعيَّنة أو تقصر وصولك إلى أجزاء من الخدمة أو الخدمة بأكملها دون إخطار أو مسؤولية.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">الاشعارات</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> ل" فني " وحدها الحق في تعديل أي شرط من شروط مقدم الخدمة أو تغيير الخدمة أو التطبيق أو تعليقهما أو إيقافهما (بما في ذلك على سبيل المثال لا الحصر، إيقاف خدمة من الخدمات المقدمة) في أي وقت، وذلك بإرسال اشعار لك من خلال الخدمة أو التطبيق أو عبر البريد الإلكتروني.
                        </li>
                        <li> يجوز ل”فني” أن تضع قيودًا على ميزات وخدمات مُعيَّنة أو تقصر وصولك إلى أجزاء من الخدمة أو الخدمة بأكملها دون إخطار أو مسؤولية
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">الاشعارات</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li> يجوز ل” فني” أن ترسل اشعاراً عن طريق إرسال اشعار عام او خاص عن الخدمة أو التطبيق.
                        </li>
                        <li> يجوز ل” فني” أن ترسل رسائل مباشرة للفني داخل صندوق الرسائل داخل التطبيق او من خلال رسائل sms او من خلال تطبيق الواتس اب او التيقرام او أي وسيلة تواصل أخرى 
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">القانون المعمول به وحل النزاعات</p>
                    <ol style={{listStyleType: 'square', marginInlineStart: '35px'}}>
                        <li>تخضع شروط مقدم الخدمة الماثلة ويطبق على تسوية أي نزاع أو مطالبة أو خلاف ينشأ عن شروط مقدم الخدمة الماثلة أو يتعلق بها أو أي انتهاك لها أو إنهائها أو تنفيذها أو تفسيرها أو صحتها أو استخدام الموقع أو الخدمة أو التطبيق، للقوانين والأنظمة المطبقة في المملكة العربية السعودية وتفسر وفقا لها.
                        </li>
                    </ol>
                </li>
                <li>
                    <p className="font-bold">للتواصل معنا</p>
                    يمكنك التواصل معنا على 920031015 او عبر الايميل cc@fanni.sa
                </li>
            </ol>
          </div>
        </div>
        <div className="w-full text-end">
          <div className="w-full max-w-[103px] inline-block text-center cursor-pointer select-none text-white bg-darkBlue rounded-[8px] h-[48px] leading-[48px] font-[600] text-[18px]" onClick={SubScribeAction}>{t('packages.agree')}</div>
        </div>
      </ModalContainer> }

    
      <Toast toast={toast} setToast={setToast} />
      {(!plans || isLoading) && <Loading showLoading={true} />}
    </div>
  );
};

export default PackagesPage;
